import {createSignal} from '@pexip/signal';

import type {UserMenuStep} from '../types';

export const userMenuStepSignal = createSignal<UserMenuStep>({
    name: 'menu:userMenuStep',
});
